<template>
  <div class="lv-section">
    <div>
      <div class="section-title">Liveview extensions</div>
      <div class="section-paragraph">
        Camoodoo comes with a big set of useful liveview extensions. All
        extensions are computed in Camoodoo and are completely independent of
        your camera model.
      </div>
      <div class="section-paragraph features">
        <icon-box src="/images/lv_guides.svg">Guides</icon-box>
        <icon-box src="/images/lv_focus_peak.svg">Focus Peaking</icon-box>
        <icon-box src="/images/lv_zebra.svg">Zebra</icon-box>
        <icon-box src="/images/lv_color.svg">Color Adjustments</icon-box>
        <icon-box src="/images/lv_mirror.svg">Selfie mirror</icon-box>
        <icon-box src="/images/lv_perspective.svg"
          >Perspective correction</icon-box
        >
        <icon-box src="/images/lv_anamorph.svg">Anamorphic correction</icon-box>
        <icon-box src="/images/lv_lut.svg">Predefined Luts</icon-box>
      </div>
    </div>
  </div>
</template>

<script>
import IconBox from "@/components/IconBox.vue";

export default {
  components: {
    IconBox,
  },
};
</script>

<style scoped>
.lv-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
  padding: var(--section-padding);
}
.features {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: var(--content-margin);
}
</style>
